<template>
  <pop-box ref="myPopbox" class="upload-popbox" :hasNotButton="true" title="生成二维码" @closeDialog="$emit('close')"
           :width="280">
    <div class="qrcode" ref="qrCodeUrl"></div>
    <div class="dialog-footer btn-wrapper">
      <el-button class="btnx-normal btn-blue" @click="onDownLoadPic">下载</el-button>
      <!--<el-button class="btnx-normal btn-bright" @click="onPreviewInfo">预览内容</el-button>-->
    </div>
  </pop-box>
</template>
<script>
  import {getAction} from "../../service/http/api";
  import QRCode from 'qrcodejs2'
  export default {
    name: 'Code',
    props: ['rowId'],
    data() {
      return {
      }
    },
    methods: {
      renderPic() {
        let url = window.location.origin + '/#/info/'+this.rowId;
        let qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: url, // 需要转换为二维码的内容
          width: 220,
          height: 220,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
      },
      onDownLoadPic(){
        const img = this.$refs.qrCodeUrl.getElementsByTagName('img')[0];
        // 构建画布
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext('2d').drawImage(img, 0, 0);
        // 构造url
        const url = canvas.toDataURL('image/png');
        const a = document.createElement('a');
        a.href=url;
        a.download = '二维码';
        a.click();
      },
      onPreviewInfo(){},
    },
    mounted() {
      this.$refs.myPopbox.isVisible = true;
      this.$nextTick(()=>{
        this.renderPic();
      })
    }
  }
</script>

<style lang="scss" scoped>
  .qrcode{
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 28px;
    padding-bottom: 26px;
    img {
      width: 132px;
      height: 132px;
      background-color: #fff; //设置白色背景色
      padding: 6px; // 利用padding的特性，挤出白边
      box-sizing: border-box;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/detect_subject_management/code.vue